module.exports = __webpack_public_path__ + "img/fuxingLOGO.78152186.png";